// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"51600a7f","254":"51027b1d","334":"71254258","763":"05f50646"}[chunkId] + ".chunk.css";
};